const FamilyDashboard = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>Family Dashboard</h1>
      <p>Welcome. Features coming soon.</p>
    </div>
  );
};

export default FamilyDashboard;